export const FILTERS_BUTTONS = {
  FILTER: 'filter',
  RESET: 'reset',
}
